export default async function CreateBooking(data, aFiles) {
  var aFormData = data;
  delete aFormData.discount_attachment; // Remove the discount_attachment field from data
  const res = await fetch(
    `${process.env.REACT_APP_ODATA_BASE_URL}BookingDashboard`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(aFormData),
    }
  );
  if (res.ok && data.discount_type !== "" && aFiles.length > 0) {
    const base64content = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result.split(",")[1]);
      reader.onerror = reject;
      reader.readAsDataURL(aFiles[0]); // Read the first file as Data URL
    });
    const oDiscountAttachment = {
      filename: aFiles[0].name,
      mimeType: aFiles[0].type,
      note: aFiles[0].name,
      content: base64content,
    };
    await fetch(
      `${process.env.REACT_APP_ODATA_BASE_URL}BookingDashboard(ID='${data.ID}',show_id='${data.show_id}',order_type='${data.order_type}',show_date='${data.show_date}',show_time='${data.show_time}')/discount_attachment`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" }, // Ensure the correct content type
        body: JSON.stringify(oDiscountAttachment),
      }
    );
    return res;
  } else if (res.ok) return res;
  else {
    throw new Error(
      "Something went wrong while reserving your booking. Please try again later"
    );
  }
}
